export enum RequirementMetStatus {
  NONE = 'none',
  SOME = 'some',
  ALL = 'all',
}
